// Mailto URL builder - eliminates nested ternaries scattered in components
const RECIPIENT = 'coachingpauasensio@gmail.com';

const HERO_SUBJECT = {
  es: 'Consulta Marketing Digital - Hacer Crecer Mi Marca',
  en: 'Digital Marketing Consultation - Grow My Brand',
  cs: 'Konzultace Digitálního Marketingu - Rozvoj Mé Značky',
};

const HERO_BODY = {
  es: 'Hola Pau,\n\nEstoy listo para llevar mi marca al siguiente nivel con marketing digital. Me interesa conocer más sobre:\n\n- Gestión de Instagram\n- Campañas en Facebook Ads\n- Estrategias mensuales personalizadas\n\nPor favor, contáctame para programar una reunión.\n\nSaludos cordiales.',
  en: 'Hello Pau,\n\nI am ready to take my brand to the next level with digital marketing. I am interested in learning more about:\n\n- Instagram management\n- Facebook Ads campaigns\n- Personalized monthly strategies\n\nPlease contact me to schedule a meeting.\n\nBest regards.',
  cs: 'Ahoj Pau,\n\nJsem připraven posunout svou značku na další úroveň s digitálním marketingem. Zajímá mě více o:\n\n- Správa Instagramu\n- Facebook Ads kampaně\n- Personalizované měsíční strategie\n\nProsím kontaktujte mě pro naplánování schůzky.\n\nS pozdravem.',
};

const PROPOSAL_SUBJECT = {
  es: 'Solicitud de Propuesta Personalizada',
  en: 'Request for Custom Proposal',
  cs: 'Žádost o personalizovanou nabídku',
};

const PROPOSAL_BODY = {
  es: 'Hola Pau,\n\nMe gustaría recibir una propuesta personalizada.',
  en: 'Hello Pau,\n\nI would like to receive a personalized proposal.',
  cs: 'Ahoj Pau,\n\nRád bych obdržel personalizovanou nabídku.',
};

const buildGmailUrl = (lang, subjectMap, bodyMap) => {
  const subject = subjectMap[lang] || subjectMap.es;
  const body = bodyMap[lang] || bodyMap.es;
  return `https://mail.google.com/mail/u/0/?view=cm&fs=1&to=${RECIPIENT}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

const CONTACT_SUBJECT = {
  es: 'Contacto desde la web — Consulta',
  en: 'Website Contact — Inquiry',
  cs: 'Kontakt z webu — Dotaz',
};

const CONTACT_BODY = {
  es: 'Hola Pau,\n\nTe escribo porque tengo una duda / me gustaría saber más sobre lo que ofreces.\n\nMi mensaje es:\n[Escribe aquí tu duda o consulta]\n\nSi necesitas algún dato adicional:\nNombre:\nPaís:\n\nGracias, quedo atento/a a tu respuesta.',
  en: 'Hi Pau,\n\nI\'m writing because I have a question / I\'d like to know more about what you offer.\n\nMy message:\n[Write your question here]\n\nIf you need any additional info:\nName:\nCountry:\n\nThanks, looking forward to your reply.',
  cs: 'Ahoj Pau,\n\nPíšu ti, protože mám dotaz / rád/a bych se dozvěděl/a více o tom, co nabízíš.\n\nMoje zpráva:\n[Sem napiš svůj dotaz]\n\nPokud potřebuješ další údaje:\nJméno:\nZemě:\n\nDíky, těším se na tvou odpověď.',
};

export const buildHeroMailto = (lang) => buildGmailUrl(lang, HERO_SUBJECT, HERO_BODY);
export const buildProposalMailto = (lang) => buildGmailUrl(lang, PROPOSAL_SUBJECT, PROPOSAL_BODY);
export const buildContactMailto = (lang) => buildGmailUrl(lang, CONTACT_SUBJECT, CONTACT_BODY);

const PLAN_SUBJECT = {
  es: 'Solicitud de Plan',
  en: 'Plan Request',
  cs: 'Žádost o plán',
};

const PLAN_BODY = {
  es: 'Hola Pau,\n\nEstoy interesado/a en este plan:\n\nPlan seleccionado: __PLAN__\n\nMe gustaría recibir más información sobre cómo funciona y los próximos pasos para poder empezar.\n\nMis datos:\nNombre:\nPaís:\nObjetivo principal:\n\nGracias.',
  en: 'Hi Pau,\n\nI\'m interested in this plan:\n\nSelected plan: __PLAN__\n\nI\'d like to receive more information on how it works and the next steps to get started.\n\nMy details:\nName:\nCountry:\nMain goal:\n\nThanks.',
  cs: 'Ahoj Pau,\n\nMám zájem o tento plán:\n\nVybraný plán: __PLAN__\n\nRád/a bych získal/a více informací o tom, jak to funguje a jaké jsou další kroky, abych mohl/a začít.\n\nMoje údaje:\nJméno:\nZemě:\nHlavní cíl:\n\nDěkuji.',
};

export const buildPlanMailto = (lang, planName) => {
  const subjectTemplate = PLAN_SUBJECT[lang] || PLAN_SUBJECT.es;
  const bodyTemplate = PLAN_BODY[lang] || PLAN_BODY.es;
  const subject = `${subjectTemplate}: ${planName}`;
  const body = bodyTemplate.replace('__PLAN__', planName);
  return `https://mail.google.com/mail/u/0/?view=cm&fs=1&to=${RECIPIENT}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

const RESULT_LABELS = { es: 'Resultado:', en: 'Result:', cs: 'Výsledek:' };
export const getResultLabel = (lang) => RESULT_LABELS[lang] || RESULT_LABELS.es;

const LANG_BADGES = { es: 'ES', en: 'EN', cs: 'CS' };
export const getLanguageBadge = (lang) => LANG_BADGES[lang] || LANG_BADGES.es;
